module.exports = __webpack_public_path__ + "media/widget/logo_white-dafb60e5.png";